import { CalendarClock, Check } from "lucide-react";
import { useBookCall } from "@/pages/Landing";

const PERKS = [
  "Complimentary — no commitment of any kind",
  "Fifteen minutes, focused entirely on you",
  "Leave with clarity on your next move",
];

export default function BookCallCTA() {
  const { open } = useBookCall();
  return (
    <section data-testid="book-cta-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="glass-strong relative p-10 md:p-16 overflow-hidden">
          <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-neon-lime/10 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-neon-cyan/10 blur-3xl pointer-events-none" />

          <div className="relative z-10 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="overline mb-4 text-neon-lime flex items-center gap-2">
                <CalendarClock size={14} /> // FREE STRATEGY CALL
              </div>
              <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] mb-6">
                Sit down with us<br />
                for <span className="text-neon-lime neon-text-cyan" style={{ textShadow: "0 0 20px rgba(57,255,20,0.5)" }}>15 minutes.</span>
              </h2>
              <p className="text-white/60 text-base md:text-lg max-w-xl mb-8">
                A short, focused conversation about your situation. We&apos;ll listen carefully, share what we&apos;ve seen work, and point you toward a sensible next step. <span className="text-white">No selling. No pressure.</span>
              </p>

              <ul className="space-y-3 mb-10">
                {PERKS.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-white/80">
                    <span className="w-5 h-5 mt-0.5 flex-shrink-0 bg-neon-lime/10 border border-neon-lime/50 flex items-center justify-center">
                      <Check size={11} className="text-neon-lime" />
                    </span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => open()}
                data-testid="book-cta-button"
                className="btn-primary !bg-neon-lime !border-neon-lime !text-[#05050A] hover:!bg-transparent hover:!text-neon-lime hover:shadow-[0_0_24px_rgba(57,255,20,0.5)]"
              >
                Reserve My Conversation <CalendarClock size={14} />
              </button>
            </div>

            <div className="lg:col-span-5">
              <div className="glass p-6 relative">
                <div className="absolute top-3 right-3 flex gap-1">
                  <span className="w-2 h-2 rounded-full bg-neon-orange/70" />
                  <span className="w-2 h-2 rounded-full bg-neon-cyan/70" />
                  <span className="w-2 h-2 rounded-full bg-neon-lime/70 animate-pulse" />
                </div>
                <div className="overline mb-4">// NEXT_AVAILABLE</div>
                <div className="space-y-3 font-mono text-xs">
                  {["MON", "TUE", "WED", "THU", "FRI"].map((d, i) => (
                    <div key={d} className="flex items-center justify-between border-b border-white/5 pb-2">
                      <span className="text-white/50 uppercase tracking-wider">{d}</span>
                      <span className="text-neon-lime">{i % 2 === 0 ? "3 slots" : "5 slots"}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-5 pt-4 border-t border-white/10 font-mono text-[10px] text-white/30 uppercase tracking-widest">
                  All times <span className="text-neon-cyan">Eastern</span> · Mon–Fri
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
